/**
 * Error codes shared by client and server.
 *
 * Codes, not messages: the client renders a translated, actionable string, and the server logs a
 * stable identifier that survives copy changes. A thrown `Error` with an English sentence is
 * neither translatable nor greppable.
 */
export function appError(code, message, options) {
    const error = {
        code,
        message,
        retryable: options?.retryable ?? RETRYABLE_CODES.includes(code),
    };
    if (options?.details !== undefined)
        error.details = options.details;
    if (options?.cause !== undefined)
        error.cause = options.cause;
    return error;
}
/**
 * Codes a caller may retry unchanged.
 *
 * Deliberately conservative: retrying something that is not on this list risks duplicating an
 * effect. Anything that needs a different request — a conflict, a validation failure — is not
 * retryable, it is *resolvable*.
 */
export const RETRYABLE_CODES = [
    'STORAGE_UNAVAILABLE',
    'UPLOAD_FAILED',
    'AI_PROVIDER_UNAVAILABLE',
    'NETWORK_UNAVAILABLE',
    'RATE_LIMITED',
    'TIMEOUT',
    'INTERNAL',
];
/** Codes that mean the user's data may be at risk and a recovery path must be offered. */
export const DATA_AT_RISK_CODES = [
    'MAP_CORRUPTED',
    'CHECKSUM_MISMATCH',
    'QUOTA_EXCEEDED',
];
export function isRetryable(code) {
    return RETRYABLE_CODES.includes(code);
}
export function isDataAtRisk(code) {
    return DATA_AT_RISK_CODES.includes(code);
}
//# sourceMappingURL=errors.js.map